<template lang="pug">
form#manage-budget-form
  div(v-if="!budgetsEnabled && !showDialogLoading")
    AppUpsellBanner(
      :feature="budgetsFeature"
      :organization-id="organization.id"
      :can-manage-billing="canManageBilling"
    )
  fieldset(v-else)
    BudgetsForm(
      allow-stop-timer
      show-members-limit
      extended-reset-options
      allow-notify-all-members
      :organization="organization"
      :duration-format="durationFormat"
      :budget-state="budgetState"
      :members-limits-state="membersLimitsState"
      :has-budget="!!project.has_budget"
      :disabled="!projectActive"
      :selected-toggle="selectedToggle"
      @change-budget-field="handleChangeBudgetField"
      @change-members-limits-field="handleChangeMembersLimitsField"
      @member-added="handleMemberAdded"
      @clear-budget="handleClearBudget"
    )
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BudgetsForm from '../budgets/BudgetsForm.vue';

export default {
  name: 'ProjectDialogTabBudgets',
  components: { BudgetsForm },
  props: {
    selectedToggle: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['organization', 'project', 'budget', 'members_limits']),
    ...mapGetters([
      'durationFormat',
      'budgetsFeature',
      'budgetsEnabled',
      'canManageBilling',
      'showDialogLoading',
      'projectActive',
    ]),
    budgetState() {
      return this.project.budget || {};
    },
    membersLimitsState() {
      return this.project.members_limits || undefined;
    },
  },
  mounted() {
    if (this.membersLimitsState) {
      this.updateField({ path: 'members_limits', value: this.membersLimitsState });
    }
  },
  methods: {
    ...mapActions(['updateField', 'resetBudget']),
    handleClearBudget() {
      this.resetBudget();
      this.$emit('clearedBudget');
    },
    handleMemberAdded() {
      this.$emit('memberAdded');
    },
    handleChangeMembersLimitsField(field, val) {
      this.updateField({ path: field, value: val });
    },
    handleChangeBudgetField(field, val) {
      this.updateField({ path: `budget.${field}`, value: val });
    },
  },
};
</script>
